import { httpCoreService } from "../services/HttpCoreService";
import type { ExportFormat } from "../types/auditLog.type";

export interface ExportVisitsParams {
  studyId?: string;
  siteId?: string;
  status?: string;
  fromDate?: string;
  toDate?: string;
  craId?: string;
  format?: ExportFormat;
}

export interface ExportTasksParams {
  visitId?: string;
  status?: string;
  fromDate?: string;
  toDate?: string;
  format?: ExportFormat;
}

export interface ExportStudySummaryParams {
  studyIds?: string[];
  format?: ExportFormat;
}

export interface ExportSiteActivityParams {
  siteIds?: string[];
  fromDate?: string;
  toDate?: string;
  format?: ExportFormat;
}

export interface ExportMilestonesParams {
  studyId?: string;
  status?: string;
  fromDate?: string;
  toDate?: string;
  format?: ExportFormat;
}

export interface IExportRepository {
  exportVisits(params: ExportVisitsParams): Promise<Blob>;
  exportTasks(params: ExportTasksParams): Promise<Blob>;
  exportStudySummary(params: ExportStudySummaryParams): Promise<Blob>;
  exportSiteActivity(params: ExportSiteActivityParams): Promise<Blob>;
  exportMilestones(params: ExportMilestonesParams): Promise<Blob>;
}

function buildParams(obj: Record<string, unknown>): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(obj)) {
    if (value === undefined || value === null || value === "") {
      continue;
    }
    if (Array.isArray(value)) {
      value.forEach((v) => params.append(key, String(v)));
    } else {
      params.append(key, String(value));
    }
  }
  return params.toString();
}

export class ExportRepository implements IExportRepository {
  async exportVisits(params: ExportVisitsParams): Promise<Blob> {
    const qs = buildParams(params as unknown as Record<string, unknown>);
    return httpCoreService.getBlob(`/exports/visits${qs ? `?${qs}` : ""}`);
  }

  async exportTasks(params: ExportTasksParams): Promise<Blob> {
    const qs = buildParams(params as unknown as Record<string, unknown>);
    return httpCoreService.getBlob(`/exports/tasks${qs ? `?${qs}` : ""}`);
  }

  async exportStudySummary(params: ExportStudySummaryParams): Promise<Blob> {
    const qs = buildParams(params as unknown as Record<string, unknown>);
    return httpCoreService.getBlob(
      `/exports/reports/study-summary${qs ? `?${qs}` : ""}`,
    );
  }

  async exportSiteActivity(params: ExportSiteActivityParams): Promise<Blob> {
    const qs = buildParams(params as unknown as Record<string, unknown>);
    return httpCoreService.getBlob(
      `/exports/reports/site-activity${qs ? `?${qs}` : ""}`,
    );
  }

  async exportMilestones(params: ExportMilestonesParams): Promise<Blob> {
    const qs = buildParams(params as unknown as Record<string, unknown>);
    return httpCoreService.getBlob(`/exports/milestones${qs ? `?${qs}` : ""}`);
  }
}
